import { styled } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

export const StyledMediaTypography = styled(MediaTypography)({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',

	'& img.notification-image': {
		alignSelf: 'center',
		maxWidth: '450px',
	},
	'& a.link-button': {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
		userSelect: 'none',
		height: 48,
		fontSize: 16,
		fontFamily: 'MuseoSansCyrl',
		fontWeight: 500,
		lineHeight: 1.75,
		minWidth: 64,
		color: '#ffffff',
		backgroundColor: '#2090ff',
		border: 'none',
		borderRadius: 8,
		padding: '6px 16px',
		textDecoration: 'none',
		transition:
			'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1)',
		'&:focus': {
			outline: 'none',
		},
		'&:hover': {
			backgroundColor: '#1664b2',
			boxShadow:
				'rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px',
		},
		'&:active': {
			boxShadow: 'none',
		},
	},
});
